// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  pro_lnglistList: [],
  pro_lnglistPage: 1,
  pro_lnglistSize: 10,
  pro_lnglistTotal: 0,
  pro_lnglistById: {},
  pro_lnglistModalType: "create",
  pro_lnglistModalVisible: false,
  currentPro_lnglist: null,
  getPro_lnglistListPending: false,
  getPro_lnglistListError: null,
  submitPro_lnglistPending: false,
  submitPro_lnglistError: null,
  deletePro_lnglistPending: false,
  deletePro_lnglistError: null,
  gongkaifabuActionsPending: false,
  gongkaifabuActionsError: null,
  dianziGenerateActionsPending: false,
  dianziGenerateActionsError: null,
  yJgeneratePassCardActionsPending: false,
  yJgeneratePassCardActionsError: null,
  productHgzGenerateActionsPending: false,
  productHgzGenerateActionsError: null,
  chooseState_show: false,
  chooseState_Fabu: false,
  allMaintainActionsPending: false,
  allMaintainActionsError: null,
  chooseState_maintain: false,
  deleteProAlllnglistPending: false,
  deleteProAlllnglistError: null,
  quantity: '',
  submitProAlllnglistPending: false,
  submitProAlllnglistError: null,
  currentPro_YjLabel: false,
  yjlabelActionsPending: false,
  yjlabelActionsError: null,
  chooseState_showCustom: false,
  getProLnglistListAllPending: false,
  getProLnglistListAllError: null,
  pro_lnglistByIdAll: {},
  pro_lnglistListAll: [],
  getProAssignFaMenPending: false,
  getProAssignFaMenError: null,
  yjlabelActionsErrormessage: '',
  dianziGenerateActionsErrormessage: '',
  yJgeneratePassCardActionsmessage: '',
  remarkModalVisible:false, //备注对话框显隐
  mediumSafetyUploadingVisible:false,
  mediumSafetyUploadingActionPending: false,
  mediumSafetyUploadingActionError: null,
  qpDataFileUploadingActionPending: false,
  qpDataFileUploadingActionError: null,
  qualityProveModalvisible:false,
  qualityProveCompileActionPending: false,
  qualityProveCompileActionError: null,
  qpParamsFileUploadingVisible:false,
  qpParamsFileUploadingId: undefined,
  qpParamsFileUploadingActionPending: false,
  qpParamsFileUploadingActionError: null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/product/redux/initialState.js